import { postAPI } from 'framework/api/http';
import { useMutation } from 'react-query';

interface RemoveVideoToRemoveBucketInterface {
  id: string;
  vid: string[];
}

export const useRemoveVideoToRemoveBucket = () => {
  const mutate = useMutation(({ id, vid }: RemoveVideoToRemoveBucketInterface) => {
    return postAPI('/external-api/remove_VideoFrom_RemoveBucket', {
      enterprise_id: id,
      video_ids: vid,
    });
  });

  return mutate;
};

export default useRemoveVideoToRemoveBucket;
